namespace SP.Data {
    export class WarehouseReasonsAndActions {

        private static warehouseActions: WarehouseActionInfo[];
        private static warehouseReasons: WarehouseReasonInfo[];

        static async getWarehouseActions(useCache = true) {
            if (useCache && (this.warehouseActions != null && this.warehouseActions.length != 0)) {
                return this.warehouseActions;
            }

            var response = await SP.get<any>("/api/v1/warehouseAction/getAllWarehouseActions");
            if (response.status == 200) {
                this.warehouseActions = response.data;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return this.warehouseActions;
        }

        static async getWarehouseReasons(useCache = true) {
            if (useCache && (this.warehouseReasons != null && this.warehouseReasons.length != 0)) {
                return this.warehouseReasons;
            }

            var response = await SP.get<any>("/api/v1/warehouseReason/getAllWarehouseReasons");
            if (response.status == 200) {
                this.warehouseReasons = response.data;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return this.warehouseReasons
        }
    }
}